require('./partials/general');
require('./partials/header');
require('./partials/forms');
require('./partials/word-slider');
require('./partials/popup');
require('./partials/tabs');
require('./partials/fancy-thumbnail');
